export type ContentType = "animation" | "character" | "news";

export interface ContentSection {
  heading: string;
  body: string[];
}

export interface ContentItem {
  id: string;
  type: ContentType;
  title: string;
  subtitle: string;
  summary: string;
  cover: string;
  author: string;
  date: string;
  readTime: string;
  tags: string[];
  group?: string;
  year?: string;
  series?: string;
  sections: ContentSection[];
}

export const contentItems: ContentItem[] = [
  {
    id: "anim-101",
    type: "animation",
    title: "第1话 · 初次的家庭访问",
    subtitle: "一切从一份报酬异常丰厚的家教委托开始",
    summary:
      "大学生泷泽遥接到一份酬劳高得离谱的家教委托，第一次踏入九条家宅邸时便察觉到，这栋房子里藏着无法言说的秘密。",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20young%20male%20home%20tutor%20with%20glasses%20standing%20in%20a%20warm%20after%20school%20classroom%20deep%20navy%20and%20warm%20orange%20palette%20cinematic%20soft%20lighting%20clean%20detailed%20digital%20art%20simple%20minimal%20uncluttered%20background%20no%20text&width=800&height=600&seq=anim-cover-101&orientation=landscape",
    author: "剧情组 · 遥川",
    date: "2024-04-06",
    readTime: "8 分钟",
    tags: ["家庭教师", "序章", "世界观", "剧情梳理"],
    series: "家庭教师",
    year: "2024",
    sections: [
      {
        heading: "剧情概要",
        body: [
          "故事从一间普通的大学自习室展开。经济拮据的二年级学生泷泽遥在兼职网站上看到一条特殊的家教招募：时薪是市面价格的十倍，唯一的附加条件是「每周需在家中留宿一晚」。犹豫再三后，他还是拨通了那个电话。",
          "委托方是城郊的九条家——一座被常青藤包裹、门前总有薄雾的老宅。迎接他的是女仆白鸟澪，她将遥领到书房，那里坐着一个沉默寡言的少年九条昴。第一堂课上，昴解出了远超同龄人的难题，却在草稿纸角落写下一行遥看不懂的符号。",
        ],
      },
      {
        heading: "分集亮点",
        body: [
          "本话用极克制的方式铺陈悬念：门廊上停摆的座钟、书房里上锁的抽屉、昴手腕上的旧伤，都只是轻轻带过，却在观众心里种下疑问。片尾曲前，遥在走廊尽头看到玲的身影一闪而过，为本作埋下第一条暗线。",
        ],
      },
      {
        heading: "隐藏伏笔",
        body: [
          "昴写下的符号在后续第12话被证实为家族旧式暗号；片头动画中出现的六芒书签，与第18话的「遗产钥匙」形状完全一致。二刷本话时，你会发现画面里几乎每一件道具都在为后文服务。",
        ],
      },
      {
        heading: "观后解析",
        body: [
          "第1话刻意把「家庭教师」这一日常职业与悬疑叙事缝合在一起，用生活流的口吻讲一个并不平凡的故事。遥作为「局外人」的视角，正是观众进入这个世界的最好入口。",
        ],
      },
    ],
  },
  {
    id: "anim-102",
    type: "animation",
    title: "第5话 · 被加密的成绩单",
    subtitle: "一张成绩单，撕开了九条家的第一道裂缝",
    summary:
      "遥在整理昴的试卷时发现一张用暗号写满的「成绩单」，而当晚，宅邸的电力系统被人整栋切断。",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20an%20encrypted%20notebook%20and%20scattered%20test%20papers%20on%20a%20dark%20study%20desk%20lit%20by%20a%20single%20warm%20lamp%20deep%20navy%20and%20orange%20palette%20cinematic%20moody%20lighting%20detailed%20digital%20art%20simple%20clean%20background%20no%20text&width=800&height=600&seq=anim-cover-102&orientation=landscape",
    author: "剧情组 · 遥川",
    date: "2024-05-04",
    readTime: "9 分钟",
    tags: ["家庭教师", "悬疑", "剧情梳理", "家族秘密"],
    series: "家庭教师",
    year: "2024",
    sections: [
      {
        heading: "剧情概要",
        body: [
          "补习进入第五周，遥逐渐发现昴的「成绩单」并不只是分数——每一科的等级都被替换成了字母与符号的组合。他尝试对照昴的课本，最终拼出一句完整的话：「不要相信屋顶上的人。」",
          "就在这天夜里，整栋宅邸突然陷入黑暗。遥摸黑下楼，撞见黑谷彻的身影从书房走出。两人在楼梯口短暂对峙，黑谷留下意味深长的一句：「你教的东西，他迟早会用在自己身上。」",
        ],
      },
      {
        heading: "分集亮点",
        body: [
          "停电段落几乎全靠声音叙事——远处的钟摆、脚步声、以及遥自己越来越急的呼吸，把紧张感推到本季前半段的高点。黑谷彻的第一次正面登场也因此格外压迫。",
        ],
      },
      {
        heading: "隐藏伏笔",
        body: [
          "昴提到「屋顶上的人」时，镜头刻意扫过窗外的鸟居形屋脊，这与第24话最终对峙的场地是同一处。黑谷拿走的文件夹上贴有的红色封条，也是「遗产篇」反复出现的识别标记。",
        ],
      },
      {
        heading: "观后解析",
        body: [
          "本话正式把故事从「日常补习」推进到「家族博弈」。遥第一次意识到，自己辅导的不只是一个孩子，而是一个被多方争夺的枢纽。角色之间的信任关系也从这里开始经受考验。",
        ],
      },
    ],
  },
  {
    id: "anim-103",
    type: "animation",
    title: "第12话 · 地下书库的对峙",
    subtitle: "当知识成为武器，教室变成了战场",
    summary:
      "为寻找破解暗号的书，遥与昴潜入封锁多年的地下书库，却在那里遇见了等待已久的玲。",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20vast%20underground%20library%20with%20towering%20bookshelves%20and%20two%20silhouetted%20figures%20deep%20navy%20and%20warm%20orange%20palette%20cinematic%20soft%20volumetric%20lighting%20detailed%20digital%20art%20simple%20elegant%20background%20no%20text&width=800&height=600&seq=anim-cover-103&orientation=landscape",
    author: "剧情组 · 遥川",
    date: "2024-07-13",
    readTime: "10 分钟",
    tags: ["家庭教师", "高潮", "剧情梳理", "角色关系"],
    series: "家庭教师",
    year: "2024",
    sections: [
      {
        heading: "剧情概要",
        body: [
          "地下书库是九条家世代封存的档案室，传闻只有家主才能进入。遥凭借昴解开的暗号打开了沉重的铁门，扑面而来的是高到看不见顶的书架与积年的尘埃。",
          "在书库深处，九条玲正安静地坐在长桌旁翻书。她没有阻止两人，反而把一本贴着六芒书签的册子推到桌前：「你既然能走到这里，就有资格知道第一层真相。」",
        ],
      },
      {
        heading: "分集亮点",
        body: [
          "玲的立场在本话彻底反转——她既像守护者，又像审判者。三人围绕「遗产」的对话层层递进，是本作对白密度与信息量最高的一场戏。",
        ],
      },
      {
        heading: "隐藏伏笔",
        body: [
          "玲提到「第一层真相」，暗示整个秘密被分为多层，为「遗产篇」的展开铺路。书架上缺了一格的书，正是第18话遥在旧宅翻到的那本。",
        ],
      },
      {
        heading: "观后解析",
        body: [
          "本话把「家庭教师」的隐喻推向高潮：真正被教导的，与其说是昴，不如说是遥自己。他在书库中学到的不仅是知识，更是一整套关于信任与责任的规则。",
        ],
      },
    ],
  },
  {
    id: "anim-104",
    type: "animation",
    title: "第18话 · 遗产的钥匙",
    subtitle: "一枚书签形状的钥匙，开启了第二个故事",
    summary:
      "遥在旧宅的座钟夹层里找到了六芒书签形状的钥匙，而它对应的，竟是所有人都以为已经消失的房间。",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20glowing%20six%20pointed%20amulet%20key%20held%20in%20a%20hand%20above%20an%20old%20grandfather%20clock%20deep%20navy%20and%20warm%20orange%20palette%20cinematic%20dramatic%20lighting%20detailed%20digital%20art%20simple%20clean%20background%20no%20text&width=800&height=600&seq=anim-cover-104&orientation=landscape",
    author: "剧情组 · 遥川",
    date: "2024-09-07",
    readTime: "9 分钟",
    tags: ["家庭教师", "转折", "剧情梳理", "遗产篇"],
    series: "家庭教师",
    year: "2024",
    sections: [
      {
        heading: "剧情概要",
        body: [
          "一连串巧合把遥引回了第一话里那台停摆的座钟。拆开后盖时，一枚六芒书签形状的钥匙滑落在地。昴看到它的瞬间，第一次露出了与年龄相符的失态。",
          "钥匙打开的是老宅西翼一扇被封死的门。门后不是房间，而是一条向下延伸的旋转阶梯。遥点亮提灯，昴站在门口，终于说出了那句迟到十八话的话：「老师，接下来你可能会有危险。」",
        ],
      },
      {
        heading: "分集亮点",
        body: [
          "从日常到超常的转场处理得极其顺滑，前半段仍是安静的补课与对话，后半段却以一把钥匙撬开了整个世界观的入口。",
        ],
      },
      {
        heading: "隐藏伏笔",
        body: [
          "钥匙上刻着的纹路与白鸟澪的耳饰完全一致，暗示她与九条家的旧事有着更深的牵连。阶梯尽头微弱的光，正对应「遗产篇」第一集的第一个镜头。",
        ],
      },
      {
        heading: "观后解析",
        body: [
          "本话是全作的结构支点：它把前十七话铺垫的所有生活细节一次性回收，并正式宣告「家庭教师」这个故事远比想象中庞大。",
        ],
      },
    ],
  },
  {
    id: "anim-105",
    type: "animation",
    title: "第24话 · 昴的抉择",
    subtitle: "在家族与自我之间，他第一次替自己作答",
    summary:
      "站在屋顶上的昴必须做出选择：继承九条家的遗产，还是跟随遥走向一条无人走过的路。",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20teenage%20boy%20standing%20on%20a%20rooftop%20at%20sunset%20overlooking%20an%20old%20mansion%20deep%20navy%20and%20warm%20orange%20palette%20cinematic%20emotional%20lighting%20detailed%20digital%20art%20simple%20clean%20sky%20background%20no%20text&width=800&height=600&seq=anim-cover-105&orientation=landscape",
    author: "剧情组 · 遥川",
    date: "2024-10-12",
    readTime: "11 分钟",
    tags: ["家庭教师", "季终", "角色成长", "剧情梳理"],
    series: "家庭教师",
    year: "2024",
    sections: [
      {
        heading: "剧情概要",
        body: [
          "季终话把舞台搬到了第一话埋下伏笔的屋顶。昴独自站在暮色里，手中同时握着象征继承的家徽与遥送他的旧钢笔。黑谷彻在阴影中等待他的答复。",
          "遥没有劝他，只是走到他身边说：「我教过你的东西，最后要由你自己选怎么用。」昴沉默良久，把家徽放回栏杆上，转身走向遥。",
        ],
      },
      {
        heading: "分集亮点",
        body: [
          "全话几乎没有动作场面，却用长达三分钟的对白与沉默完成了昴的人物弧光。结尾遥与昴并肩走下楼梯的长镜头，被不少观众视为本季最动人画面。",
        ],
      },
      {
        heading: "隐藏伏笔",
        body: [
          "昴留下的家徽在片尾彩蛋中被一只看不清面孔的手捡起，直接引出「遗产篇」的新对手。黑谷那句「我们会再见的」也为后续埋线。",
        ],
      },
      {
        heading: "观后解析",
        body: [
          "本话回答了开篇提出的问题：家庭教师究竟能改变什么。答案不是拯救，而是让一个人有勇气为自己做决定。这也是本作最核心的价值观。",
        ],
      },
    ],
  },
  {
    id: "anim-106",
    type: "animation",
    title: "特别篇 · 暑假补习合宿",
    subtitle: "紧张的谜团之间，难得的一次喘息",
    summary:
      "在主线告一段落后的夏天，遥带着昴与千夏前往海边小镇，进行一场轻松却暗藏心思的补习合宿。",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20three%20students%20studying%20on%20a%20sunny%20seaside%20veranda%20with%20notebooks%20deep%20navy%20and%20warm%20orange%20palette%20cinematic%20bright%20summer%20lighting%20detailed%20digital%20art%20simple%20clean%20background%20no%20text&width=800&height=600&seq=anim-cover-106&orientation=landscape",
    author: "剧情组 · 遥川",
    date: "2024-11-02",
    readTime: "7 分钟",
    tags: ["家庭教师", "日常", "外传", "温情"],
    series: "家庭教师·外传",
    year: "2024",
    sections: [
      {
        heading: "剧情概要",
        body: [
          "特别篇跳出了主线的时间线，讲述一场没有危机的暑假。遥在海边小镇租下旧民宿，白天补习，傍晚一起看海。千夏带来了自制点心，昴第一次主动和大家聊起自己的过去。",
          "在一次夜谈中，昴问遥：「如果我不是九条家的人，你还会来教我吗？」遥没有正面回答，只是把第二天要讲的内容提前写在了黑板上。",
        ],
      },
      {
        heading: "分集亮点",
        body: [
          "本篇几乎没有悬疑，却把三位主要角色的日常性格补全得恰到好处。片尾蝉鸣渐弱、黑板满分公式的特写，是本作的温柔收束。",
        ],
      },
      {
        heading: "隐藏伏笔",
        body: [
          "昴提到童年时「和姐姐一起看过的海」，与「遗产篇」中海边灯塔的关键场景形成呼应。千夏随身携带的旧相机，也是后续重要道具。",
        ],
      },
      {
        heading: "观后解析",
        body: [
          "作为外传，本篇的意义在于让观众重新确认：这个故事真正珍贵的，是那些没有被危机占据的平静时刻。",
        ],
      },
    ],
  },
  {
    id: "char-201",
    type: "character",
    title: "泷泽遥",
    subtitle: "温和而坚韧的家庭教师，故事的视角与灵魂",
    summary:
      "本作主角。家境普通的大学生，靠着惊人的耐心与共情能力，一步步走进了九条家的世界，也成为昴真正的引路人。",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20character%20portrait%20of%20a%20kind%20young%20male%20university%20student%20tutor%20with%20glasses%20and%20gentle%20smile%20deep%20navy%20and%20warm%20orange%20palette%20soft%20cinematic%20lighting%20clean%20detailed%20digital%20art%20simple%20plain%20background%20no%20text&width=600&height=600&seq=char-cover-201&orientation=squarish",
    author: "角色组 · 青叶",
    date: "2024-04-20",
    readTime: "6 分钟",
    tags: ["家庭教师", "主角", "人物解析"],
    group: "主角",
    sections: [
      {
        heading: "人物简介",
        body: [
          "二十岁的普通大学生，主修教育学。为了负担学费四处兼职，性格平实、不善言辞，却有一种让人愿意开口的能力。他是全作唯一一个「没有秘密的人」，也正因如此，成为照出他人内心的一面镜子。",
        ],
      },
      {
        heading: "性格特质",
        body: [
          "遥的魅力不在天赋，而在坚持。他会为一个没听懂的知识点反复讲解，也会在明知危险时选择留下。他的勇敢不是无所畏惧，而是带着恐惧仍然前进。",
        ],
      },
      {
        heading: "关键剧情",
        body: [
          "第12话地下书库、第18话找到遗产钥匙、第24话屋顶上的那番话，是遥人物弧光的三个支点。他从「被雇佣的人」逐渐变成「主动承担的人」。",
        ],
      },
      {
        heading: "综合评价",
        body: [
          "遥是近年少见的「低配置主角」：没有异能、没有背景，靠的只是作为教师的责任心。这种设定让整部作品的情感落点格外扎实。",
        ],
      },
    ],
  },
  {
    id: "char-202",
    type: "character",
    title: "九条昴",
    subtitle: "背负家族遗产的天才少年，故事真正的谜题",
    summary:
      "九条家独子，智商极高却极度封闭自我。在被遥辅导的过程中，第一次学会了相信别人，也开始质疑自己被安排的命运。",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20character%20portrait%20of%20a%20quiet%20teenage%20boy%20student%20with%20sharp%20eyes%20and%20dark%20hair%20deep%20navy%20and%20warm%20orange%20palette%20soft%20cinematic%20lighting%20clean%20detailed%20digital%20art%20simple%20plain%20background%20no%20text&width=600&height=600&seq=char-cover-202&orientation=squarish",
    author: "角色组 · 青叶",
    date: "2024-04-27",
    readTime: "7 分钟",
    tags: ["家庭教师", "主角", "人物解析", "家族秘密"],
    group: "主角",
    sections: [
      {
        heading: "人物简介",
        body: [
          "十五岁的九条家继承人。学业对他而言毫无挑战，真正困住他的是「必须成为家主」这一既定命运。他用冷漠当作盔甲，直到遥的出现让这层盔甲第一次出现裂缝。",
        ],
      },
      {
        heading: "性格特质",
        body: [
          "昴表面疏离，内里却极度渴望被当作普通少年对待。他会偷偷收藏遥批改过的试卷，也会在无人时反复练习一句普通的「谢谢」。",
        ],
      },
      {
        heading: "关键剧情",
        body: [
          "从第5话写下暗号，到第18话第一次示弱，再到第24话拒绝继承——昴的每一次选择都在回答同一个问题：我是九条家的昴，还是我自己的昴。",
        ],
      },
      {
        heading: "综合评价",
        body: [
          "昴是本作最大的谜题，也是情感核心。他的成长线证明了：真正的教育不是塑造，而是唤醒一个人为自己做决定的能力。",
        ],
      },
    ],
  },
  {
    id: "char-203",
    type: "character",
    title: "绫濑千夏",
    subtitle: "情报灵通的同学，紧绷剧情里的那束光",
    summary:
      "遥的大学同学，也是本作的气氛担当。看似大大咧咧，实则观察力惊人，多次在关键时刻为遥提供意想不到的线索。",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20character%20portrait%20of%20a%20cheerful%20young%20woman%20with%20short%20wavy%20hair%20and%20bright%20expression%20deep%20navy%20and%20warm%20orange%20palette%20soft%20cinematic%20lighting%20clean%20detailed%20digital%20art%20simple%20plain%20background%20no%20text&width=600&height=600&seq=char-cover-203&orientation=squarish",
    author: "角色组 · 青叶",
    date: "2024-05-11",
    readTime: "5 分钟",
    tags: ["家庭教师", "配角", "人物解析"],
    group: "配角",
    sections: [
      {
        heading: "人物简介",
        body: [
          "教育学部的活跃学生，校内情报网络的中心人物。她总能第一时间知道最新的传闻与动向，是遥了解校园与外界信息的窗口。",
        ],
      },
      {
        heading: "性格特质",
        body: [
          "开朗、直接、有点爱管闲事，但分寸感极好。她从不过度追问遥的私事，却总在他需要时出现。",
        ],
      },
      {
        heading: "关键剧情",
        body: [
          "她在第12话偷偷整理出的旧报纸剪报，成为遥推理九条家历史的关键；第18话她替遥保管了那枚钥匙的拓印，是后续剧情的重要凭证。",
        ],
      },
      {
        heading: "综合评价",
        body: [
          "千夏看似功能型角色，却承担了全作大量的情绪缓冲。她让这个偏冷的悬疑故事始终保有一份人间的暖意。",
        ],
      },
    ],
  },
  {
    id: "char-204",
    type: "character",
    title: "白鸟澪",
    subtitle: "沉默的护卫，九条家最深的一道伤口",
    summary:
      "九条家的女仆兼护卫，身手不凡、话却极少。她与九条家的旧事有着不为人知的牵连，立场始终扑朔迷离。",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20character%20portrait%20of%20an%20elegant%20stoic%20maid%20guard%20with%20silver%20hair%20and%20calm%20eyes%20deep%20navy%20and%20warm%20orange%20palette%20soft%20cinematic%20lighting%20clean%20detailed%20digital%20art%20simple%20plain%20background%20no%20text&width=600&height=600&seq=char-cover-204&orientation=squarish",
    author: "角色组 · 青叶",
    date: "2024-06-08",
    readTime: "6 分钟",
    tags: ["家庭教师", "配角", "人物解析", "家族秘密"],
    group: "配角",
    sections: [
      {
        heading: "人物简介",
        body: [
          "负责九条宅邸内外一切事务的女仆，也是家族的秘密护卫。她的过去与那枚六芒书签耳饰紧紧相连——那本不属于女仆的配饰，暗示着她的另一重身份。",
        ],
      },
      {
        heading: "性格特质",
        body: [
          "冷静、克制、忠诚，却并非盲从。她对昴的保护带着一种近乎补偿的意味，仿佛在为某段无法挽回的往事赎罪。",
        ],
      },
      {
        heading: "关键剧情",
        body: [
          "第12话她在书库外的徘徊、第18话钥匙上与她耳饰一致的纹路，都在暗示她可能是「遗产」真正的知情者之一。",
        ],
      },
      {
        heading: "综合评价",
        body: [
          "澪是本作悬念密度最高的角色之一。她的每一次沉默都比台词更有信息量，也让「遗产篇」多了一层情感重量。",
        ],
      },
    ],
  },
  {
    id: "char-205",
    type: "character",
    title: "黑谷彻",
    subtitle: "优雅的对立面，把野心藏在微笑背后的组织干部",
    summary:
      "神秘组织的核心干部，行事冷静、进退有度。他既不急于抢夺，也不掩饰目的，是压在主角一行人头顶的长期威胁。",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20character%20portrait%20of%20a%20sinister%20elegant%20man%20in%20a%20long%20dark%20coat%20with%20a%20faint%20smile%20deep%20navy%20and%20warm%20orange%20palette%20soft%20cinematic%20dramatic%20lighting%20clean%20detailed%20digital%20art%20simple%20plain%20background%20no%20text&width=600&height=600&seq=char-cover-205&orientation=squarish",
    author: "角色组 · 青叶",
    date: "2024-07-06",
    readTime: "6 分钟",
    tags: ["家庭教师", "反派", "人物解析"],
    group: "反派",
    sections: [
      {
        heading: "人物简介",
        body: [
          "反派阵营的统筹者，总是比所有人早一步到达现场。他不屑于暴力，更擅长用信息和心理施压，把对手一步步逼到自己想要的位置。",
        ],
      },
      {
        heading: "性格特质",
        body: [
          "从容、理性、目的明确。他欣赏遥这样的对手，也正因如此，他在第5话留给遥的那句话，与其说是威胁，不如说是一种邀请。",
        ],
      },
      {
        heading: "关键剧情",
        body: [
          "第5话停电夜的对峙、第24话屋顶的等待，构成他与主角组的两场正面交锋。片尾捡起家徽的那只手，几乎确定就是他。",
        ],
      },
      {
        heading: "综合评价",
        body: [
          "黑谷彻的成功在于「不喧哗的威胁」。他不靠叫嚣制造压力，而是靠「他永远知道得比你多」这一事实，让观众全程保持紧绷。",
        ],
      },
    ],
  },
  {
    id: "char-206",
    type: "character",
    title: "九条玲",
    subtitle: "掌纹里握着整座宅邸的女人",
    summary:
      "九条家当代掌权者，昴的姐姐。她既是家族的守护者，也是规则的制定者，立场在守护与利用之间反复摇摆。",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20character%20portrait%20of%20a%20composed%20mature%20woman%20head%20of%20an%20old%20family%20with%20tied%20hair%20and%20piercing%20gaze%20deep%20navy%20and%20warm%20orange%20palette%20soft%20cinematic%20lighting%20clean%20detailed%20digital%20art%20simple%20plain%20background%20no%20text&width=600&height=600&seq=char-cover-206&orientation=squarish",
    author: "角色组 · 青叶",
    date: "2024-07-20",
    readTime: "6 分钟",
    tags: ["家庭教师", "配角", "人物解析", "家族秘密"],
    group: "配角",
    sections: [
      {
        heading: "人物简介",
        body: [
          "九条家最年轻的掌权者，也是昴唯一的血亲。她比任何人都清楚「遗产」的分量，因此她的每一个决定都夹杂着家族责任与手足之情。",
        ],
      },
      {
        heading: "性格特质",
        body: [
          "理性、克制、长于权衡。她可以为了家族牺牲自己，却始终无法对弟弟真正狠下心。这份矛盾正是她最有魅力的地方。",
        ],
      },
      {
        heading: "关键剧情",
        body: [
          "第12话书库中的「第一层真相」，是她主动递出的橄榄枝。而第24话昴拒绝继承时她的沉默，则预示家族内部的裂痕正式开始。",
        ],
      },
      {
        heading: "综合评价",
        body: [
          "玲是介于守护者与操控者之间的灰色角色。她的存在让「家族」这一主题不再是非黑即白，也让本作多了一份成年人的沉重。",
        ],
      },
    ],
  },
  {
    id: "news-301",
    type: "news",
    title: "《家庭教师》第三季制作决定，预计明年春季开播",
    subtitle: "官方公布先导视觉图与新一季制作阵容",
    summary:
      "官方正式宣布《家庭教师》第三季「遗产篇」进入制作阶段，并放出一张氛围先导视觉图，预计于明年春季与观众见面。",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20dramatic%20season%20announcement%20key%20visual%20with%20a%20mansion%20silhouette%20and%20warm%20sunrise%20deep%20navy%20and%20orange%20palette%20cinematic%20epic%20lighting%20detailed%20digital%20art%20simple%20clean%20poster%20background%20no%20text&width=800&height=600&seq=news-cover-301&orientation=landscape",
    author: "资讯组 · 空木",
    date: "2024-10-20",
    readTime: "4 分钟",
    tags: ["家庭教师", "动画资讯", "制作决定"],
    sections: [
      {
        heading: "概要",
        body: [
          "官方于周末的特别直播中公布了《家庭教师》第三季的制作决定。新一季副标题为「遗产篇」，将承接第二季结尾屋顶对峙的剧情线。",
        ],
      },
      {
        heading: "详细内容",
        body: [
          "直播同时公开了一张先导视觉图：黎明时分的九条宅邸在暖橙色天光中显出新轮廓。主创团队表示，新一季会进一步展开家族史与「钥匙」背后多层真相。",
          "官方尚未公布具体话数，但确认主要角色配音阵容保持不变，并会新增数名关键角色。",
        ],
      },
      {
        heading: "相关影响",
        body: [
          "消息公布后相关话题迅速登上讨论榜，原作与既有关联商品的检索量同步上升。更多细节预计在下一次官方活动中公开。",
        ],
      },
    ],
  },
  {
    id: "news-302",
    type: "news",
    title: "官方发布《遗产篇》角色设定集，收录大量未公开草稿",
    subtitle: "厚达两百余页，附带主创访谈",
    summary:
      "官方宣布将推出《家庭教师·遗产篇》角色设定集，收录主要角色定稿、初期草稿与主创访谈，是理解人物设计的珍贵资料。",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20an%20open%20artbook%20with%20character%20design%20sketches%20on%20a%20wooden%20desk%20deep%20navy%20and%20warm%20orange%20palette%20soft%20cinematic%20lighting%20detailed%20digital%20art%20simple%20clean%20background%20no%20text&width=800&height=600&seq=news-cover-302&orientation=landscape",
    author: "资讯组 · 空木",
    date: "2024-09-28",
    readTime: "3 分钟",
    tags: ["家庭教师", "动漫资讯", "设定集"],
    sections: [
      {
        heading: "概要",
        body: [
          "官方设定集将完整收录《家庭教师》主角组的形象定稿与多轮修改草稿，并首次公开部分被舍弃的早期方案。",
        ],
      },
      {
        heading: "详细内容",
        body: [
          "设定集共两百余页，除角色视觉外，还包含配色说明、服装考据与场景概念图。书末附有主创关于「如何设计一个可信的家庭教师」的访谈。",
        ],
      },
      {
        heading: "相关影响",
        body: [
          "对角色研究爱好者而言，这本设定集提供了难得的官方参考，也补全了许多只有在细节层面才能看到的用心之处。",
        ],
      },
    ],
  },
  {
    id: "news-303",
    type: "news",
    title: "《家庭教师》主题曲演唱者公布，旋律呼应主线情感",
    subtitle: "新曲将作为第三季片头曲使用",
    summary:
      "官方揭晓第三季片头主题曲的演唱阵容，并透露新曲以「引导与被引导」为核心意象，与剧情主题高度契合。",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20concert%20stage%20with%20warm%20spotlight%20and%20floating%20music%20notes%20deep%20navy%20and%20orange%20palette%20cinematic%20glowing%20lighting%20detailed%20digital%20art%20simple%20clean%20background%20no%20text&width=800&height=600&seq=news-cover-303&orientation=landscape",
    author: "资讯组 · 空木",
    date: "2024-09-10",
    readTime: "3 分钟",
    tags: ["家庭教师", "动漫资讯", "音乐"],
    sections: [
      {
        heading: "概要",
        body: [
          "第三季片头曲演唱阵容正式公开，官方表示新曲从创作阶段就以「引导与被引导」为题，希望旋律本身就能承载主角与学生的关系。",
        ],
      },
      {
        heading: "详细内容",
        body: [
          "制作人透露，新曲在编曲上刻意保留了学院气息的钢琴动机，并在副歌加入明亮的人声层次，以此呼应故事从日常走向宏大的过程。",
        ],
      },
      {
        heading: "相关影响",
        body: [
          "主题曲一经公布便收获良好反响，不少观众表示仅凭试听片段就已对第三季充满期待。",
        ],
      },
    ],
  },
  {
    id: "news-304",
    type: "news",
    title: "原作漫画迎来连载五周年，官方感谢活动开启",
    subtitle: "回顾五年，从一间教室走向庞大世界观",
    summary:
      "原作漫画迎来连载五周年，官方上线特别感谢页面，以时间线形式回顾从第1话到最新话的关键剧情节点。",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20five%20year%20anniversary%20celebration%20with%20stacked%20manga%20volumes%20and%20warm%20confetti%20deep%20navy%20and%20orange%20palette%20cinematic%20festive%20lighting%20detailed%20digital%20art%20simple%20clean%20background%20no%20text&width=800&height=600&seq=news-cover-304&orientation=landscape",
    author: "资讯组 · 空木",
    date: "2024-08-18",
    readTime: "5 分钟",
    tags: ["家庭教师", "动漫资讯", "漫画"],
    sections: [
      {
        heading: "概要",
        body: [
          "自第1话刊载至今，《家庭教师》漫画已走过整整五年。官方为此上线感谢活动，并整理了一条贯穿全作的时间线。",
        ],
      },
      {
        heading: "详细内容",
        body: [
          "时间线从遥第一次按下门铃开始，途经地下书库、遗产钥匙，直到最新话的家族裂痕，完整呈现故事规模的扩张轨迹。",
          "官方同时公布了一组作者手绘的周年纪念插图，作为对读者长期支持的回应。",
        ],
      },
      {
        heading: "相关影响",
        body: [
          "五周年活动不仅唤起了老读者的回忆，也让不少新观众通过时间线快速了解了作品全貌。",
        ],
      },
    ],
  },
  {
    id: "news-305",
    type: "news",
    title: "声优访谈：如何为沉默的昴注入灵魂",
    subtitle: "「他每一句台词，都要先想三十秒」",
    summary:
      "九条昴的配音演员在最新访谈中分享了塑造这一角色的心得，坦言「沉默」才是最难的表演。",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20recording%20studio%20microphone%20booth%20with%20warm%20ambient%20light%20deep%20navy%20and%20orange%20palette%20cinematic%20soft%20lighting%20detailed%20digital%20art%20simple%20clean%20background%20no%20text&width=800&height=600&seq=news-cover-305&orientation=landscape",
    author: "资讯组 · 空木",
    date: "2024-08-02",
    readTime: "6 分钟",
    tags: ["家庭教师", "动漫资讯", "声优"],
    sections: [
      {
        heading: "概要",
        body: [
          "在最新一期访谈中，昴的配音演员回顾了自己如何理解并演绎这个「话少却内心汹涌」的少年。",
        ],
      },
      {
        heading: "详细内容",
        body: [
          "他表示，昴的难点不在台词量，而在每一次开口前的停顿。为了让沉默也有层次，他会在录音前为每句台词设定情绪背景。",
          "谈到第24话屋顶那场戏，他说那是「整季最需要克制的一次表演」，因为昴的成长必须由观众自己看出来，而不是靠语气强调。",
        ],
      },
      {
        heading: "相关影响",
        body: [
          "访谈公开后，许多观众重新回看第24话，并表示对昴这一角色的理解有了新的角度。",
        ],
      },
    ],
  },
  {
    id: "news-306",
    type: "news",
    title: "《家庭教师》线下主题展会将于下月开幕",
    subtitle: "还原地下书库场景，设角色专区",
    summary:
      "官方宣布《家庭教师》主题线下展将于下月开幕，现场将还原剧中多个经典场景，并设置角色资料专区与周边展售。",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20an%20exhibition%20hall%20with%20glowing%20display%20panels%20and%20warm%20accent%20lights%20deep%20navy%20and%20orange%20palette%20cinematic%20immersive%20lighting%20detailed%20digital%20art%20simple%20clean%20background%20no%20text&width=800&height=600&seq=news-cover-306&orientation=landscape",
    author: "资讯组 · 空木",
    date: "2024-07-25",
    readTime: "4 分钟",
    tags: ["家庭教师", "动漫资讯", "活动"],
    sections: [
      {
        heading: "概要",
        body: [
          "主题展将集中呈现《家庭教师》的世界观，包括场景还原、角色资料与主创手稿等多个展区。",
        ],
      },
      {
        heading: "详细内容",
        body: [
          "其中「地下书库」实景还原区最受关注，主办方以一比一比例搭建通向书库的铁门与长桌，让参观者体验剧中第12话的关键场景。",
          "另设角色专区，按主角、配角与反派分区展示人物设定，方便观众对照剧情深入理解。",
        ],
      },
      {
        heading: "相关影响",
        body: [
          "展会预约通道开启后反响热烈，官方提示将视情况追加参观场次。",
        ],
      },
    ],
  },
];

export const heroSlides = [
  {
    id: "anim-101",
    type: "animation" as ContentType,
    kicker: "世界观序章",
    title: "初次的家庭访问",
    description:
      "一份报酬异常丰厚的家教委托，一栋藏满秘密的老宅。故事从按住门铃的那一刻开始。",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20mysterious%20old%20mansion%20at%20dusk%20with%20a%20young%20tutor%20walking%20toward%20glowing%20windows%20deep%20navy%20and%20warm%20orange%20palette%20cinematic%20atmospheric%20lighting%20detailed%20digital%20art%20simple%20clean%20composition%20no%20text&width=1920&height=1080&seq=home-hero-01&orientation=landscape",
  },
  {
    id: "char-202",
    type: "character" as ContentType,
    kicker: "角色专题",
    title: "九条昴 · 谜题本人",
    description:
      "他解得出任何难题，却解不开自己的命运。一次角色深读，重新理解这个安静的天才少年。",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20quiet%20teenage%20boy%20standing%20alone%20in%20an%20old%20study%20with%20dramatic%20window%20light%20deep%20navy%20and%20warm%20orange%20palette%20cinematic%20moody%20lighting%20detailed%20digital%20art%20simple%20clean%20composition%20no%20text&width=1920&height=1080&seq=home-hero-02&orientation=landscape",
  },
  {
    id: "anim-104",
    type: "animation" as ContentType,
    kicker: "剧情转折",
    title: "遗产的钥匙",
    description:
      "一枚六芒书签形状的钥匙，撬开了所有人都以为消失的房间。第二段故事，就此开启。",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20glowing%20amulet%20key%20floating%20above%20an%20unlocked%20old%20wooden%20door%20deep%20navy%20and%20warm%20orange%20palette%20cinematic%20dramatic%20glowing%20lighting%20detailed%20digital%20art%20simple%20clean%20composition%20no%20text&width=1920&height=1080&seq=home-hero-03&orientation=landscape",
  },
];